const FALLBACK_EUR_TO_GBP = 0.86;
const RATE_URL = "https://api.frankfurter.app/latest?from=EUR&to=GBP";

let cachedRate = null;
let pendingRequest = null;

/** Fetch the current EUR → GBP mid-market rate (cached for the session). */
export async function getEurToGbpRate() {
  if (cachedRate != null) return cachedRate;
  if (pendingRequest) return pendingRequest;

  pendingRequest = fetch(RATE_URL)
    .then((res) => {
      if (!res.ok) throw new Error(`FX request failed: ${res.status}`);
      return res.json();
    })
    .then((data) => {
      const rate = Number(data?.rates?.GBP);
      if (!Number.isFinite(rate) || rate <= 0) {
        throw new Error("Invalid EUR→GBP rate");
      }
      cachedRate = rate;
      return rate;
    })
    .catch(() => FALLBACK_EUR_TO_GBP)
    .finally(() => {
      pendingRequest = null;
    });

  return pendingRequest;
}

/** Convert a euro amount to whole pounds using the given rate. */
export function convertEurToGbp(amountEur, rate = FALLBACK_EUR_TO_GBP) {
  const amount = Number(amountEur);
  if (!Number.isFinite(amount)) return null;
  return Math.round(amount * rate);
}

export function formatGbp(amount) {
  if (amount == null) return null;
  return `£${amount}`;
}
